import template from './template.html'
import Controller from './wskTaskCard.controller'

export default {
  restrict: 'E',
  template,
  bindings: {
    task: '=',
  },
  controller: Controller,
  controllerAs: 'vm',
}
